/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.socialMediaLinks.internal

import features.socialMediaLinks.models.SocialMediaLinksModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.socialMediaLinks.internal.SocialMediaLinksUseCase.Params

internal class SocialMediaLinksUseCase : AsyncUseCase<SocialMediaLinksModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,

    )

    private val socialMediaLinksService: SocialMediaLinksService = SocialMediaLinksServiceImpl()

    override suspend fun run(params: Params): Result<SocialMediaLinksModel> {
        return socialMediaLinksService.getSocialMediaLinks(
            overrideHeaders = params.overrideHeaders,

        )
    }
}
